import actions from "actions";
import constants from "constants";
import React, { Component } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import ChangePasswordForm from "components/Authorization/ChangePassword/ChangePassword.jsx";
import InputField from "components/InputField/InputField";
import SelectField from "components/InputField/SelectField";
import FileField from "components/InputField/FileField";
import axios from "axios";
import { API_ADMIN_USERS } from "../../constants/api";

const { ERROR_TYPE_USER_UPDATE_ERROR, CHANGE_PASSWORD_SAGA } = constants;

const {
  loadCurrentUser,
  updateUserSaga,
  addValidateError,
  cleanErrors,
  changePasswordSaga,
} = actions;

const labels = {
  first_name: "First name",
  last_name: "Last name",
  email: "Email",
  user_type: "I am a",
  imc: "IMC Number",
  registration: "Accreditation Number",
  practice_name: "Practice Name",
  phone: "Phone",
  hospital: "Hospital",
  title: "Title",
  gender: "Gender",
  profession: "Profession",
  ipna_member: "IGPNEA (IPNA)",
  branch: "Branch",
  country: "Country",
  accreditation: "Accreditation",
  pin_number: "NMBI PIN Number",
  discipline: "Discipline",
  new_user_type: "I am a",
  new_disciplines: "Discipline",
  password: "Password",
  sponsor_type: "Sponsor Type",
  company_name: "Company",
};

const sponsorTypes = [
  {
    value: 0,
    label: "Pharmaceutical",
  },
  {
    value: 1,
    label: "Private Hospital",
  },
];

const sponsorTypeLabel = {
  pharmaceutical: 0,
  private_hospital: 1,
};

const titles = [
  { label: "Dr.", value: "dr" },
  { label: "Mr.", value: "mr" },
  { label: "Ms.", value: "ms" },
  { label: "Mrs.", value: "mrs" },
  { label: "Prof.", value: "prof" },
];

const getFormData = ({
  first_name,
  last_name,
  sponsor_type,
  title,
  email,
  company_name,
  avatar,
}) => {
  const formData = new FormData();

  formData.append("user[first_name]", first_name);
  formData.append("user[last_name]", last_name);
  formData.append("user[sponsor_type]", sponsor_type);
  formData.append("user[title]", title);
  formData.append("user[email]", email);
  formData.append("user[company_name]", company_name);

  if (avatar) {
    formData.append("user[avatar]", avatar);
  }

  return formData;
};

const apiUpdateUser = ({ id, data }) =>
  axios.put(`${API_ADMIN_USERS}/${id}`, data);

class ProfileRepresentative extends Component {
  constructor(props) {
    super(props);
    const user = this.props.user;
    this.state = {
      user,
      passwordChange: {
        id: user.id,
        email: user.email,
        password: "",
        password_confirmation: "",
        old_password: "",
      },
      passwordVisibility: {
        password: false,
        password_confirmation: false,
        old_password: false,
      },
    };
  }

  componentWillMount() {
    this.props.loadCurrentUser();
    this.props.cleanErrors();
    this.props.cleanErrorsPasswordChange();
    this.setState({ user: this.props.user });
  }

  onSubmit = async () => {
    try {
      const id = this.state.user.id;
      const data = getFormData(this.state.user);
      await apiUpdateUser({ id, data });
      toast.success("Profile has been updated");
      this.props.loadCurrentUser();
    } catch (error) {
      console.log(error);
    }
  };

  onFieldChange = (e) => {
    const userData = {
      ...this.state.user,
      ...{
        [e.target.name]: e.target.value,
      },
    };

    this.setState({ user: userData });
  };

  handleFileChange = (file) =>
    this.setState({
      user: {
        ...this.state.user,
        avatar: file,
        avatar_url: URL.createObjectURL(file),
      },
    });

  onPasswordsFieldChange = (e) => {
    const passwordChangeData = {
      ...this.state.passwordChange,
      ...{
        [e.target.name]: e.target.value,
      },
    };

    this.setState({ passwordChange: passwordChangeData });
  };

  onSubmitPasswordChange = (e) => {
    e.preventDefault();
    this.props.changePassword(this.state.passwordChange);
  };

  onPasswordChangeVisibility = (field, value) => {
    this.setState({
      passwordVisibility: {
        ...this.state.passwordVisibility,
        [field]: value,
      },
    });
  };

  render() {
    const {
      title,
      first_name,
      last_name,
      email,
      company_name,
      sponsor_type,
      avatar_url,
    } = this.state.user;

    const {
      errors,
      errorsFrontend,
      passwordChangeErrors,
      passwordChangeErrorsFrontend,
    } = this.props;

    const sponsorType =
      sponsorTypeLabel[sponsor_type] || sponsorTypeLabel[sponsor_type] === 0
        ? sponsorTypeLabel[sponsor_type]
        : sponsor_type;

    const outErrors = Object.keys(errorsFrontend || {}).length
      ? errorsFrontend
      : errors;

    const outErrorsPasswordChange = Object.keys(
      passwordChangeErrorsFrontend || {}
    ).length
      ? passwordChangeErrorsFrontend
      : errors;

    return (
      <main className="site--width" style={{ marginBottom: 30 }}>
        <h2 className="main_title">PROFILE</h2>
        <div style={{ width: 500, margin: "auto" }}>
          <div>
            <img
              src={avatar_url}
              alt="profile-image"
              style={{
                width: 160,
                height: 160,
                borderRadius: "50%",
                display: "block",
                margin: "auto",
                objectFit: "cover",
              }}
            />
            <FileField
              className="col s12"
              field_name="avatar"
              onChange={(e) => this.handleFileChange(e.target.value)}
              label={labels["avatar"]}
              // errors={errors["avatar"]}
            />
          </div>
          <SelectField
            className="col s12"
            label={labels["title"]}
            onChange={this.onFieldChange}
            // errors={errors["title"]}
            autoComplete="new-password"
            field_name="title"
            value={title}
            options={titles}
          />
          <div style={{ marginTop: 16 }}>
            <SelectField
              className="col s12"
              label={labels["sponsor_type"]}
              onChange={this.onFieldChange}
              // errors={errors["sponsor_type"]}
              autoComplete="new-password"
              field_name="sponsor_type"
              value={sponsorType}
              options={sponsorTypes}
            />
          </div>
          {[
            {
              field_name: "first_name",
              value: first_name,
              className: "col s12 m6",
            },
            {
              field_name: "last_name",
              value: last_name,
              className: "col s12 m6",
            },
            {
              field_name: "email",
              value: email,
              type: "email",
              className: "col s12",
            },
            {
              field_name: "company_name",
              value: company_name,
              className: "col s12",
            },
          ].map(
            (e) =>
              e.field_name && (
                <InputField
                  className="col s12"
                  label={labels[e.field_name]}
                  onChange={this.onFieldChange}
                  // errors={errors[e.field_name]}
                  autoComplete="new-password"
                  {...e}
                />
              )
          )}
          <button
            className="button_classic"
            style={{ display: "block", margin: "auto", marginTop: 15 }}
            onClick={this.onSubmit}
          >
            Update
          </button>
        </div>
        <h2 className="main_title" id="change_password">
          CHANGE PASSWORD
        </h2>
        <ChangePasswordForm
          user={this.state.passwordChange}
          onFieldChange={this.onPasswordsFieldChange}
          onSubmit={this.onSubmitPasswordChange}
          errors={outErrorsPasswordChange || {}}
          passwordVisibility={this.state.passwordVisibility}
          onPasswordChangeVisibility={this.onPasswordChangeVisibility}
        />
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  errors: state.errors[ERROR_TYPE_USER_UPDATE_ERROR],
  errorsFrontend: state.errors[`${ERROR_TYPE_USER_UPDATE_ERROR}_FRONTEND`],
  user: state.users.user,
  passwordChangeErrors: state.errors[CHANGE_PASSWORD_SAGA],
  passwordChangeErrorsFrontend:
    state.errors[`${CHANGE_PASSWORD_SAGA}_FRONTEND`],
});

const mapDispatchToProps = (dispatch) => ({
  loadCurrentUser: () => dispatch(loadCurrentUser()),
  updateUser: (user) => dispatch(updateUserSaga(user)),
  validateUser: (errors) =>
    dispatch(addValidateError(ERROR_TYPE_USER_UPDATE_ERROR, errors)),
  cleanErrors: () => dispatch(cleanErrors(ERROR_TYPE_USER_UPDATE_ERROR)),
  validatePasswordChange: (errors) =>
    dispatch(addValidateError(CHANGE_PASSWORD_SAGA, errors)),
  cleanErrorsPasswordChange: () => dispatch(cleanErrors(CHANGE_PASSWORD_SAGA)),
  changePassword: (changePasswordData) =>
    dispatch(changePasswordSaga(changePasswordData)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileRepresentative);



// WEBPACK FOOTER //
// ./src/containers/RepresentativeProfile/index.jsx